(function () {
  var GIFT_PROPERTY = "_auto_gift";
  var configElement = document.querySelector("[data-auto-gift-config]");

  if (!configElement) return;

  var config = JSON.parse(configElement.textContent);
  var threshold = Number(config.threshold) || 10000;
  var variantId = Number(config.variantId);

  if (!variantId) return;

  function buildStlBundleId() {
    return "stl-" + Date.now() + "-" + Math.random().toString(36).slice(2, 9);
  }

  var selectors = {
    cartRoutes: "[data-cart-routes]",
    cartCount: "[data-cart-count]",
    cartCountBubble: "[data-cart-count-bubble]"
  };

  var classes = {
    hidden: "hide"
  };

  var syncTimer;
  var processing = false;
  var isInternalUpdate = false;

  function isCartPage() {
    return document.body.classList.contains("template-cart") || window.location.pathname === "/cart";
  }

  function getCartRoutes() {
    var routes = document.querySelector(selectors.cartRoutes);

    if (!routes) {
      return {
        cartUrl: "/cart",
        cartAddUrl: "/cart/add",
        cartChangeUrl: "/cart/change"
      };
    }

    return JSON.parse(routes.innerHTML);
  }

  function fetchCart() {
    var routes = getCartRoutes();

    return fetch(routes.cartUrl + ".js", {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      return response.json();
    });
  }

  function getGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];

      if (item.variant_id === variantId && item.properties && item.properties[GIFT_PROPERTY] === "true") {
        return {
          item: item,
          line: i + 1
        };
      }
    }

    return null;
  }

  function getCartTotalExcludingGift(cart) {
    return cart.items.reduce(function (total, item) {
      if (item.variant_id === variantId && item.properties && item.properties[GIFT_PROPERTY] === "true") {
        return total;
      }

      return total + item.final_line_price;
    }, 0);
  }

  function updateCartCount(quantity) {
    var cartCount = document.querySelector(selectors.cartCount);
    var cartCountBubble = document.querySelector(selectors.cartCountBubble);

    if (cartCount) {
      cartCount.textContent = quantity;
    }

    if (cartCountBubble) {
      cartCountBubble.classList.toggle(classes.hidden, quantity < 1);
    }
  }

  function addGift() {
    var routes = getCartRoutes();

    isInternalUpdate = true;

    return fetch(routes.cartAddUrl + ".js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: (function () {
              var props = {};
              var stlBundle = buildStlBundleId();

              props[GIFT_PROPERTY] = "true";
              props._stl_item = "true";
              props._stl_bundle = stlBundle;

              return props;
            })()
          }
        ]
      })
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || (json.status && json.status !== 200)) {
          throw new Error(json.description || "Auto gift add failed");
        }

        return json;
      });
    }).finally(function () {
      isInternalUpdate = false;
    });
  }

  function removeGift(line) {
    var routes = getCartRoutes();

    isInternalUpdate = true;

    return fetch(routes.cartChangeUrl + ".js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || (json.status && json.status !== 200)) {
          throw new Error(json.description || "Auto gift remove failed");
        }

        return json;
      });
    }).finally(function () {
      isInternalUpdate = false;
    });
  }

  function syncGift(cart) {
    var giftLine = getGiftLine(cart);
    var eligibleTotal = getCartTotalExcludingGift(cart);
    var shouldHaveGift = eligibleTotal > threshold;

    if (shouldHaveGift && !giftLine) {
      return addGift().then(fetchCart).then(function (updatedCart) {
        updateCartCount(updatedCart.item_count);
        return { cart: updatedCart, changed: true };
      });
    }

    if (!shouldHaveGift && giftLine) {
      return removeGift(giftLine.line).then(fetchCart).then(function (updatedCart) {
        updateCartCount(updatedCart.item_count);
        return { cart: updatedCart, changed: true };
      });
    }

    updateCartCount(cart.item_count);
    return Promise.resolve({ cart: cart, changed: false });
  }

  function handleSyncResult(result) {
    if (result && result.changed && isCartPage()) {
      window.location.reload();
    }

    return result;
  }

  function runSync() {
    if (processing || isInternalUpdate) {
      return Promise.resolve({ changed: false });
    }

    processing = true;

    return fetchCart()
      .then(syncGift)
      .then(handleSyncResult)
      .catch(function (error) {
        // eslint-disable-next-line no-console
        console.error("[auto-gift]", error);
        return { changed: false };
      })
      .finally(function () {
        processing = false;
      });
  }

  function scheduleSync() {
    if (isInternalUpdate) return Promise.resolve({ changed: false });

    clearTimeout(syncTimer);

    return new Promise(function (resolve) {
      syncTimer = setTimeout(function () {
        runSync().then(resolve);
      }, 200);
    });
  }

  function afterCartChange() {
    clearTimeout(syncTimer);

    if (window.cartUpdateInProgress) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          afterCartChange().then(resolve);
        }, 100);
      });
    }

    return runSync();
  }

  function shouldWatchRequest(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?/i.test(url);
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__autoGiftPatched) return;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var requestUrl = arguments[0];

      if (typeof requestUrl !== "string" && requestUrl && requestUrl.url) {
        requestUrl = requestUrl.url;
      }

      return originalFetch.apply(this, arguments).then(function (response) {
        if (
          !isInternalUpdate &&
          typeof requestUrl === "string" &&
          shouldWatchRequest(requestUrl) &&
          !isCartPage()
        ) {
          scheduleSync();
        }

        return response;
      });
    };

    window.fetch.__autoGiftPatched = true;
  }

  function patchJQuery() {
    if (!window.jQuery || window.jQuery.__autoGiftPatched) return;

    window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (
        !isInternalUpdate &&
        settings &&
        settings.url &&
        shouldWatchRequest(settings.url) &&
        !isCartPage()
      ) {
        scheduleSync();
      }
    });

    window.jQuery.__autoGiftPatched = true;
  }

  function init() {
    patchFetch();
    patchJQuery();
    runSync();
  }

  window.AutoGift = {
    scheduleSync: scheduleSync,
    runSync: runSync,
    afterCartChange: afterCartChange
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
